/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Org_Kpi_Ai_Cost_BadgeInputs */



/**
* | output |
* | --- |
* | "{count} requests this period" |
*
* @param {Partner_Org_Kpi_Ai_Cost_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_ai_cost_badge = /** @type {((inputs: Partner_Org_Kpi_Ai_Cost_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Ai_Cost_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Anfragen in diesem Zeitraum`)
	return /** @type {LocalizedString} */ (`${i?.count} requests this period`)
});